import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import AccessDenied from "./accessDenied";

const PrivateRoute = ({ component: Component, chapter }) => {
  const sortedMenuNames = useSelector((state) => state.roleControllerReducer.sortedMenuNames);
  const availableChapters = useSelector((state) => state.roleManagementReducer.availableChapters);

  const [statusShowChildItem, setStatusShowChildItem] = useState(false);

  const showChildItem = () => {
    if (sortedMenuNames && availableChapters) {
      const matchingObject = availableChapters.find(
        (item) => item.chapterId === sortedMenuNames[chapter]?.id,
      );
      return !!matchingObject;
    } else {
      return false;
    }
  };

  useEffect(() => {
    setStatusShowChildItem(showChildItem());
  }, [availableChapters, sortedMenuNames]);

  return <>{statusShowChildItem ? <Component /> : <AccessDenied />}</>;
};

export default PrivateRoute;
